<template>
  <index></index>
</template>

<script>
  import index from './IndexMain'

  export default {
    name: 'home-header',
    components: {
      index
    }
  }
</script>



// WEBPACK FOOTER //
// Index.vue?6120d2de